import script from "./Subscription.vue?vue&type=script&setup=true&lang=js"
export * from "./Subscription.vue?vue&type=script&setup=true&lang=js"

import "./Subscription.vue?vue&type=style&index=0&id=568294e2&lang=scss&scoped=true"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-568294e2"]])

export default __exports__